var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "download-container" }, [
    _vm.loading
      ? _c("div", { staticClass: "status-message" }, [
          _c("div", { staticClass: "spinner" }),
          _vm._v(" "),
          _c("p", [_vm._v("Downloading app...")])
        ])
      : _vm.error
      ? _c("div", { staticClass: "error-message" }, [
          _c("p", [_vm._v(_vm._s(_vm.error))]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "retry-button", on: { click: _vm.retryDownload } },
            [_vm._v("Retry Download")]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "back-button", on: { click: _vm.back } },
            [_vm._v("Go Back")]
          )
        ])
      : _c("div", { staticClass: "manual-download" }, [
          _c("p", [_vm._v("If download doesn't start automatically:")]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "download-button", on: { click: _vm.downloadApp } },
            [_vm._v("Download Manually")]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b0d340e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0d340e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadApp.vue
// module id = 475
// module chunks = 0